import React from 'react';
import { getProxyUrl } from '../../utils/image';
import { usePlayer } from '../../hooks/player';
import { getPlayerCurrentSeasonStats } from '../../utils/player';
import { getPlayerUrl } from '../../utils/routes';

const FALLBACK_IMAGE_URL = 'https://img.svenskelitfotboll.se/0.png';

function SquadPlayer({ player, team }) {
  const { displayName, imageHalf200, number, fogisId, teamAbbrv } = player;
  const [extendedPlayer, loading, error] = usePlayer(fogisId);

  const getShirtNumber = () => {
    if (player?.number) {
      return player?.number;
    }

    if (
      extendedPlayer?.currentClub &&
      extendedPlayer?.currentClub?.length > 0
    ) {
      return extendedPlayer?.currentClub[0]?.shirtNumber;
    }

    return '#';
  };

  const playerImage = getProxyUrl(imageHalf200 || FALLBACK_IMAGE_URL);
  const currentSeasonStats =
    !loading && extendedPlayer
      ? getPlayerCurrentSeasonStats(extendedPlayer)
      : {
          goals: 0,
          matchesPlayed: 0,
          matchesStarted: 0,
          assists: 0,
        };

  const teamLogo = getProxyUrl(team?.logoImageUrl, 300, 300);

  const getName = (n) => {
    if (n) {
      const [firstName] = n?.split(' ');
      const completeLastName = n?.split(' ')?.slice(1)?.join(' ');

      return {
        firstName,
        lastName: completeLastName,
      };
    }

    return {
      firstName: player?.givenName,
      lastName: player?.surName,
    };
  };

  return (
    <div className="scrollable-content-width col-4 mb-3 ms-2 ms-lg-0 me-3 me-ls-0 me-lg-0 px-0 px-lg-2">
      <div className="data-container">
        <div className="row">
          <div className="col-7 col-lg-8">
            <div className="player-bust ps-2 pe-0">
              <div className="player-bust__images">
                <img
                  className="player-bust__player-image"
                  src={playerImage}
                  alt=""
                />
                <img
                  className="player-bust__team-image"
                  src={teamLogo}
                  alt=""
                />
              </div>
              <a
                href={getPlayerUrl(teamAbbrv, displayName)}
                className="player-bust__info text-decoration-none"
              >
                <p className="m-0 player-bust__number fw-bold">
                  {getShirtNumber()}
                </p>
                <p className="m-0 player-bust__name">
                  <p className="m-0 player-bust__first-name">
                    {getName(displayName)?.firstName}
                  </p>
                  <p className="m-0 player-bust__last-name">
                    {getName(displayName)?.lastName}
                  </p>
                </p>
              </a>
            </div>
          </div>
          <div className="col-5 col-lg-4 d-flex flex-column pb-3 ps-0">
            <div className="data-container__row heading-h6 d-flex text-transform-none px-2 px-lg-3 py-2">
              <span>Spelade</span>
              <span className="ms-auto">
                {currentSeasonStats?.matchesPlayed}
              </span>
            </div>
            <div className="data-container__row heading-h6 d-flex text-transform-none px-2 px-lg-3 py-2">
              <span>Startade</span>
              <span className="ms-auto">
                {currentSeasonStats?.matchesStarted}
              </span>
            </div>
            <div className="data-container__row heading-h6 d-flex text-transform-none px-2 px-lg-3 py-2">
              <span>Mål</span>
              <span className="ms-auto">{currentSeasonStats?.goals}</span>
            </div>
            <div className="data-container__row heading-h6 d-flex text-transform-none px-2 px-lg-3 py-2">
              <span>Assists</span>
              <span className="ms-auto">{currentSeasonStats?.assists}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SquadPlayer;
